module.exports = __webpack_public_path__ + "static/media/singleProductBcg.a32fd146.jpeg";